import React, { useState } from 'react'

import { Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import TableHeader from '../Table/Header'
import { rowHeight } from '../Table/constants'

const useStyles = makeStyles({
  tableContainer: {
    maxWidth: 1024,
  },
})

const TableView = ({ data, rowsPerPage }) => {
  const months = data.months
  const styles = useStyles()
  const [page, setPage] = useState(0)
  const tableViewRowHeight = rowHeight / 2

  const handleChangePage = (_event, newPage) => {
    setPage(newPage)
  }

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, months.length - page * rowsPerPage)

  return (
    <React.Fragment>
      <TableContainer
        mx="auto"
        className={styles.tableContainer}
      >
        <Table
          aria-label="prospect stages by month table"
          aria-labelledby="prospect history"
        >
          <TableHeader
            columns={[
              { id: 'month', label: 'Month' },
              { id: 'following', label: 'Following', align: 'right' },
              { id: 'applying', label: 'Applying', align: 'right' },
              { id: 'applied', label: 'Applied', align: 'right' },
            ]}
          />
          <TableBody>
            {months.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((m, index) => (
              <TableRow
                style={{ height: tableViewRowHeight }}
                key={index}
              >
                <TableCell>{m.month}</TableCell>
                <TableCell align="right">{m.following}</TableCell>
                <TableCell align="right">{m.applying}</TableCell>
                <TableCell align="right">{m.applied}</TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: tableViewRowHeight * emptyRows }}>
                <TableCell colSpan={12} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[rowsPerPage]}
        component="div"
        count={months.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </React.Fragment>
  )
}
TableView.propTypes = {
  data: PropTypes.object,
  rowsPerPage: PropTypes.number,
}

TableView.defaultProps = {
  data: {
    months: [],
  },
  rowsPerPage: 12,
}

export default TableView
